
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useAxiosFile from "../../actions/useaxios";
import { useEffect, useState } from "react";
import { isEmpty } from "../../actions/common";
import { toast } from "react-toastify";
import { Col, Row } from "react-bootstrap";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";

function StoreSeo() {
  //   const { toggle } = useSelector((state) => state.admin_panel.User);
  const { toggle, payload, token } = useSelector(
    (state) => state.seller_panel.User
  );
  const navigate = useNavigate();

  const axiosFile = useAxiosFile();
  const { id, _id } = useParams()
  const [Datas, SetDatas] = useState([]);
  const [Search, SetSearch] = useState("");
  const [category, SetCategory] = useState("");
  const [Contents, SetContents] = useState({
    answer: "",
    question: ""
  });
  const [ValidateError, SetValidateError] = useState({});

  var { pathname } = useLocation()
  pathname = pathname.split('/')[1]
  console.log("pathname======", pathname)
  useEffect(() => {
    if (pathname == "store-faq" || pathname == "edit-store-faq") GetLocations();
  }, [Search, pathname]);

  const GetLocations = async () => {

    var resp = await axiosFile.shopaction({ from: 'admin', action: pathname, Search: Search, _id, id });
    console.log("dasdasdsadsa", resp);
    if (pathname == "edit-store-faq") {
      SetContents(resp.data?.[0]?.Faq?.find(it => it._id == _id))
    } else SetDatas(resp?.data[0]?.Faq);
    // SetDatas(resp?.data)
  };



  async function _delete(params, showhome) {
    let resp = await axiosFile.shopaction({ from: 'admin', action: 'delete-store-faq', _id: params, id });
    console.log("resp.success ", resp.success, resp?.msg);
    if (resp.success == "success") {
      toast.success(`Deleted from Documnet Successfully`);
      GetLocations();
      return
    }
    return toast.error(resp?.msg ? resp?.msg : "Something Went Wrong");

  }
  async function _add(params, showhome) {
    if (isEmpty(Contents.answer)) {
      SetValidateError({
        answer: "answer required"
      })
      toast.error("answer required");
      return false
    }
    if (isEmpty(Contents.question)) {
      SetValidateError({
        question: "question required"
      })
      toast.error("question required");
      return false
    }
    console.log("ididid", id)

    let resp = await axiosFile.shopaction({ _id: id, from: 'admin', action: 'add-store-faq', Contents });
    console.log("resp.success ", resp.success, resp?.msg);
    if (resp.success == "success") {
      toast.success(`Added Contents Successfully`);
      navigate(`/store-faq/${id}`)
      SetCategory("")
      // GetLocations();
      return
    }
    SetValidateError(resp.error)
    return toast.error(resp?.msg ? resp?.msg : "Something Went Wrong");

  }
  async function _edit(params, showhome) {
    if (isEmpty(Contents.answer)) {
      SetValidateError({
        answer: "answer required"
      })
      toast.error("answer required");
      return false
    }
    if (isEmpty(Contents.question)) {
      SetValidateError({
        question: "question required"
      })
      toast.error("question required");
      return false
    }
    let resp = await axiosFile.shopaction({ from: 'admin', action: 'edit-store-faq-action', _id, id, Contents });
    console.log("resp.success ", resp.success, resp?.msg);
    if (resp.success == "success") {
      toast.success(`Edited from Documnet Successfully`);
      navigate(`/store-faq/${id}`)
      SetCategory("")
      // GetLocations();
      return
    }
    SetValidateError(resp.error)
    return toast.error(resp?.msg ? resp?.msg : "Something Went Wrong");

  }

  console.log("++++++++++++++++++++", Contents)

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) {
      console.log("page", page);
      console.log("sizePerPage", sizePerPage);
    },
    onSizePerPageChange: function (page, sizePerPage) {
      console.log("page", page);
      console.log("sizePerPage", sizePerPage);
    },
  });
  const columns = [

    {
      dataField: "question",
      text: "Question",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          {console.log('cellcell', cell, row)}
          <p>{cell}</p>
        </>
      )
    }, {
      dataField: "answer",
      text: "Answer",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          {console.log('cellcell', cell, row)}
          <p>{cell}</p>
        </>
      )
    },
    {
      dataField: "_id",
      text: "Edit",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <div onClick={() => { navigate(`/edit-store-faq/${(id)}/${row?._id}`); SetContents({}) }}>
            <p>Edit</p></div>
        </>
      )
    },
    {
      dataField: "_id",
      text: "Delete",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <div onClick={() => _delete(cell)}>

            <p>{'Delete'}</p>
          </div>
        </>
      )
    }

  ];


  return (

    <section id="content-wrapper">
      <div class="row">
        <div className="top_title_sec">
          <div>
            <p className="page_title">Shops</p>
          </div>

          {/* <div className="rightside">
                        <div className='order_calendar_div'>
                              <p className={opacity == "true" ? "hiding_caltxt" : ""}>Start Date</p>
                              <img className='order_calendar_ic' src={require('../../assets/images/icons/calendar.png')}/>
                              <Datetime onChange={()=>{setOpacity("true")}} className='order_datepick'/>
                            </div>

                            <p className='order_totxt'>To</p>
                            <div className='order_calendar_div'>
                              <p className={opacityEnd == "true" ? "hiding_calendtxt" : ""}>End Date</p>
                              <img className='order_calendar_ic' src={require('../../assets/images/icons/calendar.png')}/>
                              <Datetime onChange={()=>{setEndOpacity("true")}} className='order_datepick'/>
                            </div>
                        </div> */}
        </div>
        {
          pathname == "store-faq" ?
            <button
              type="button"
              className="blue_btn add_deliveryprsn"
              onClick={() => { navigate(`/add-store-faq/${id}`); SetContents({}) }}
            >
              Add Shop faq
            </button> :
            <button
              type="button"
              className="blue_btn add_deliveryprsn"
              onClick={() => navigate(`/store-faq/${id}`)}
            >
              Back
            </button>
        }
        {
          pathname == "store-faq" &&
          <button
            type="button"
            className="blue_btn add_deliveryprsn"
            onClick={() => navigate("/shoplist")}
          >
            Back
          </button>}
      </div>
      {
        pathname == "store-faq" ?
          <div className="row mt-4">
            <div className="sec_border">
              <div className="row">
                {/* <div className="col-xxl-4 col-xl-4 col-lg-3 col-md-3 col-sm-12 col-12">
                            <div className="whole_searchbar white_bg">
                              
                              <input placeholder="Search term" />
                            </div>
                          </div> */}


                          <div className="orders_tabs">
                            <Row>
                              <Col sm={12}>
                                {true && (
                                  <div className="ffd_table row">
                                    <BootstrapTable
                                      bootstrap4
                                      keyField="id"
                                      columns={columns}
                                      data={Datas}
                                      options={{
                                        onExportToCSV: Datas,
                                      }}
                                      exportCSV
                                      pagination={pagination}
                                      noDataIndication="No Shops found"
                                    />
                                  </div>
                                )}
                              </Col>
                            </Row>
                          </div>
                        </div>
            </div>
          </div>
          :
          <div className="sec_border">
            <Row className="mdv_inputrow">
              <Col
                xxl={6}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={12}
                className="mb-3"
              >
                <p className="mdv_inplabel"> Question </p>
                <input
                  className="mdv_cmninput"
                  value={Contents?.question ?? ""}
                  type="text"
                  placeholder="Enter Question"
                  onChange={(e) => SetContents({
                    ...Contents, ...{ question: e?.target?.value }
                  })}
                />
                {ValidateError && ValidateError?.question && (
                  <span className="error-msg">
                    {ValidateError.question}
                  </span>
                )}
              </Col>
              <Col
                xxl={6}
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={12}
                className="mb-3"
              >
                <p className="mdv_inplabel"> Answer</p>
                <input
                  className="mdv_cmninput"
                  value={Contents?.answer ?? ""}
                  type="text"
                  placeholder="Enter Answer"
                  onChange={(e) => SetContents({
                    ...Contents, ...{ answer: e?.target?.value }
                  })}
                />
                {ValidateError && ValidateError?.answer && (
                  <span className="error-msg">
                    {ValidateError.answer}
                  </span>
                )}
              </Col>




            </Row>
            <div className="mdv_update_dualbtn mt-3">
              <button
                className="blue_btn mdv_update"
                onClick={() => { pathname == "add-store-faq" ? _add() : _edit() }}
              >
                {pathname == "add-store-faq" ? "save" : "edit"}
              </button>
            </div>
          </div>
      }
    </section>

  );
}

export default StoreSeo;
